
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const common_app = namespace("common_app");
const base = namespace("base");
const customer = namespace("customer");
const user = namespace("user");

@Component({
  inheritAttrs: false,
  model: {
    prop: "plateCode",
    event: "input"
  }
})
export default class InputCarNum extends Vue {
  @base.Action getDictionaryList;
  @customer.Action getCustomerList;
  @common_app.State country;
  @user.State defaultPlateProvince;
  @Prop({ default: "" })
  plateCode: string;
  @Prop({ default: 1 }) // 1：输入框 2：搜索下拉框
  mode: number;
  carNum: string = "";
  carNumList: any[] = [];
  plateNum: string = "";
  plateCodeOptions: any[] = [];
  created() {
    this.init();
  }
  init() {
    this.getDictionaryList("plate_province").then(data => {
      this.carNumList = data;
      if (!this.$provinceValue && this.carNumList[0]) {
        this.$emit("input", (this.defaultPlateProvince || this.carNumList[0].dataValue) + this.$plateValue);
      }
    });
  }
  searchKey: string = "";
  remoteMethod(val) {
    if (val) {
      this.searchKey = val;
      this.updateValue(val, "input");
      this.getCustomerList({
        pageSize: 20,
        pageNum: 1,
        searchKey: this.$provinceValue + val
      }).then(data => {
        this.plateCodeOptions = this.$safeValue(data, "data.list", "").map(item => {
          item.plateCode = item.plateCode.slice(1);
          return item;
        });
      });
    } else {
      this.searchKey = "";
      this.plateCodeOptions = [];
    }
  }
  updateValue(val, type) {
    val = val.toUpperCase();
    if (type === "input") {
      this.$emit("input", this.$provinceValue + val);
    } else {
      this.$emit("input", val + this.$plateValue);
      this.$emit("change", val + this.plateNum);
    }
  }
  handleBlur() {
    setTimeout(() => {
      this.plateNum = this.searchKey;
      this.emitUpdate("all");
    }, 50);
  }
  handleChooseVehicle() {
    this.emitUpdate("all");
  }
  emitUpdate(type) {
    if (type === "input") {
      this.$emit("input", this.$provinceValue + this.plateNum);
    } else if (type === "change") {
      this.$emit("change", this.$provinceValue + this.plateNum);
    } else {
      this.$emit("input", this.$provinceValue + this.plateNum);
      this.$emit("change", this.$provinceValue + this.plateNum);
    }
  }
  get $provinceValue() {
    return this.plateCode ? this.plateCode.substring(0, 1) : this.defaultPlateProvince;
  }
  get $plateValue() {
    return this.plateCode ? this.plateCode.slice(1) : "";
  }
  @Watch("plateCode")
  plateCodeChange(val) {
    if (val) {
      this.plateNum = val.slice(1);
      this.searchKey = val.slice(1);
      this.plateCodeOptions = [
        {
          vehicleCode: "defineKey",
          plateCode: val.slice(1)
        }
      ];
    } else {
      this.plateNum = "";
      this.plateCodeOptions = [];
    }
  }
}
